// extracted by mini-css-extract-plugin
export default {"logo":"logo_logo__RbtjL","logo__brand":"logo_logo__brand__squqP"};